<template>
  <div class="checkmark-container" ref="check">
    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
      <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Checkmark',

  props: {
    size: {
      type: String,
      default: '4rem'
    },

    color: {
      type: String,
      default: '#10B981'
    }
  },

  mounted () {
    this.$refs.check.style.setProperty('--size', this.size)
    this.$refs.check.style.setProperty('--color', this.color)
  }
}
</script>

<style lang="postcss">
.checkmark-container {
  --size: 1rem;
  --color: #10B981;
}

.checkmark {
  width: var(--size);
  height: var(--size);
  margin:0 auto;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px var(--color);
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark-circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: var(--color);
  fill: none;
  animation: stroke .6s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;
}

.checkmark-check {
  transform-origin: 50% 50%;
  stroke-width: 4;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke .3s cubic-bezier(0.650, 0.000, 0.450, 1.000) .8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px var(--size) var(--color);
  }
}
</style>